'use client'

import { useEffect } from 'react'
import { track } from '@/utils/analytics'
import { describeSiteInteraction, type InteractionArea } from '@/utils/siteInteractions'

export default function SiteInteractionAnalytics() {
  useEffect(() => {
    const capture = (event: MouseEvent) => {
      if (!(event.target instanceof Element)) return
      const element = event.target.closest<HTMLElement>('a[href], button[data-analytics-action]')
      if (!element || element.closest(
        '#analytics-preferences-dialog, [data-analytics-ignore], .ph-no-capture, form, [contenteditable="true"]'
      )) return
      if (element.matches(':disabled, [aria-disabled="true"]')) return
      const area: InteractionArea = element.closest('footer') ? 'footer'
        : element.closest('nav, header') ? 'header'
          : element.closest('article') ? 'article' : 'main'
      const interaction = describeSiteInteraction({
        currentUrl: window.location.href,
        area,
        href: element.getAttribute('href'),
        action: element.dataset.analyticsAction,
      })
      if (interaction) track(interaction.name, interaction.properties)
    }

    // Capture before client navigation changes the source page. Keyboard link
    // activation also emits click; middle-button navigation uses auxclick.
    const click = (event: MouseEvent) => { if (event.button === 0) capture(event) }
    const middleClick = (event: MouseEvent) => { if (event.button === 1) capture(event) }
    document.addEventListener('click', click, true)
    document.addEventListener('auxclick', middleClick, true)
    return () => {
      document.removeEventListener('click', click, true)
      document.removeEventListener('auxclick', middleClick, true)
    }
  }, [])
  return null
}
